<script>
  import { Navigate } from "svelte-router-spa";
</script>

<div id="footer">
  <div class="text-grey uppercase f-link">
    <Navigate to="imprint"><a>Imprint</a></Navigate>
  </div> - 
  <div class="text-grey uppercase f-link">Privacy Policy</div> -
  <div class="text-grey uppercase f-link">
    built with <a href="https://gun.eco/" target="_blank">gun</a>
  </div>
</div>

<style>
  #footer {
    position: absolute;
    bottom: 0;
    width: 100%;
    text-align: center;
    font-size: 0.55rem;
    padding-bottom: 1px;
    color: grey;
  }
  .f-link {
    display: inline-block;
  }
  a:hover {
      color: white !important;
  }

</style>
